import { getRawValue } from '@/modules/Project/Fields/field-registry'
import type { Entity } from '@/modules/Project/types'
import type { Project } from '@/modules/Projects/useProjects'
import type { HubFile } from '@/modules/Workspaces/KnowledgeHub/Hubs/types'
import { invariant } from '@/shared/utils/typeAssertions'

export function parseHubEntities(props: { agent: Project; entities: Entity[] }): HubFile[] {
  const { agent, entities } = props
  const hubFiles: HubFile[] = []

  for (const entity of entities) {
    const hubFile: HubFile = {
      agentId: agent.id,
      createdAt: '',
      entityId: entity.id,
      fileName: '',
      fileURL: '',
      path: '',
      summary: '',
      uploadStatus: 'idle',
      workspaceId: agent.workspaceId,
    }
    hubFiles.push(hubFile)

    for (const field of entity.fields.values()) {
      for (const property of agent.properties) {
        if (field.propertyId !== property.id) {
          continue
        }

        switch (property.name) {
          case 'file':
            invariant(field.type === 'file')
            hubFile.createdAt = field.createdAt
            hubFile.fileURL = field.manualValue || ''
            hubFile.uploadStatus = field.status
            break
          case 'path':
            invariant(field.type === 'text')
            hubFile.fileName = field.manualValue?.split('/').pop() || ''
            hubFile.path = field.manualValue || ''
            break
          case 'summary':
            invariant(field.type === 'text')
            hubFile.summary = getRawValue(field)?.toString() ?? ''
            break
        }
      }
    }
  }

  return hubFiles
}
